import { PaymentCompleteProvider } from '@context/Payment/PaymentComplete';
import PaymentCompleteView from './PaymentCompleteView';

const PaymentComplete = () => {
  return (
    <PaymentCompleteProvider>
      <PaymentCompleteView />
    </PaymentCompleteProvider>
  );
};

export default PaymentComplete;
